import React, { useEffect, useRef, useState } from 'react'
import { Button, message } from 'antd'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { useWarehouseModel } from '../../warehouseModel'
import { IVRMWarehouseDetail } from '../../warehouseTypes'
import { getFormValidatorErrText } from '@/utils/utils'
import { debounce } from 'lodash'
import { YhAuth } from '@/components/auth/YhAuth'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { YHDetailNav } from '@/components/YHDetailNav'
import { ShelfTable } from './ShelfTable'

export function WarehouseDatalis() {
    const { editFormVal, updateEditFormVal, editWarehouse,shelfLoadData, getWarehouseOne, saveLoading, setSaveLoading } = useWarehouseModel()
    const formRef = useRef<IYhFormRef>()
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel()
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (!editFormVal.id) {
            getWarehouseOne(detailsInfo.id)
        }
    }, [detailsInfo])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav('4-3-2') && updateEditFormVal(null)
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, '4-3')
    }

    //仓库修改提交
    const onSubmit = async () => {
        setSaveLoading(true)
        formRef.current
            ?.validateFields()
            .then((res) => {
                editWarehouse({ ...res, 
                    id: detailsInfo.id as string ,
                    status:res.status?1:0
                } as IVRMWarehouseDetail).then((res) => {
                    res && onClose()
                })
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }

    //实时缓存
    const onChange = (changedValues: any) => {
        updateEditFormVal(changedValues)
    }

    const baseFormItem: IYhFormItemsBox = {
        title: '仓库详情',
        style: { marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '仓库编码',
                fieldName: 'code',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '仓库名称',
                fieldName: 'name',
                rules: [{ required: true, message: '请输入仓库名称' }],
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '仓库类型',
            //     fieldName: 'shopName',
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '仓库负责人',
                fieldName: 'contact',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系电话',
                fieldName: 'phone',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系地址',
                fieldName: 'address',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '备注',
                fieldName: 'note',
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "状态",
                fieldName: "status",
            }, 
        ],
    }

    const warehouseFromConfig: IYhFormBox<any> = {
        formRef,
        // labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: editFormVal,
        onChange,
        boxs: [baseFormItem],
    }
    const action = (
        <>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={saveLoading}
                onClick={debounce(() => {
                    onSubmit()
                }, 900)}
            >
                {saveLoading ? '保存中' : '保存'}
            </Button>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    message.success('重置成功')
                }}
            >
                重置
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={() => replaceNav(selectedNavId, '4-3')}>
                取消
            </Button>
        </>
    )

    return (
        <>
            <YHDetailNav title="仓库管理详情" btns={action} style={{ marginBottom: '8px' }} />
            <YhFormBox {...warehouseFromConfig} />
            {/* {editFormVal.id ? <WarehouseDetailsTabs /> : null} */}
            <ShelfTable />
        </>
    )
}
